import type { Condition } from '@capture/shared';

const OPS = ['and', 'or', 'eq', 'ne', 'gt', 'lt', 'in', 'matches'] as const;

interface Props {
  condition: Condition;
  fieldNames: string[];
  onChange: (next: Condition) => void;
}

export function ConditionBuilder({ condition, fieldNames, onChange }: Props) {
  const isComposite = condition.op === 'and' || condition.op === 'or';
  return (
    <div className="condition-builder">
      <label>
        Operator
        <select value={condition.op} onChange={(e) => {
          const op = e.target.value as Condition['op'];
          if (op === 'and' || op === 'or') onChange({ op, args: [] });
          else onChange({ op, args: ['', ''] });
        }}>
          {OPS.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      </label>
      {isComposite ? (
        <div className="condition-builder__children">
          {(condition.args as Condition[]).map((child, i) => (
            <ConditionBuilder
              key={i}
              condition={child}
              fieldNames={fieldNames}
              onChange={(next) => onChange({ ...condition, args: (condition.args as Condition[]).map((c, ci) => ci === i ? next : c) })}
            />
          ))}
          <button type="button" onClick={() => onChange({ ...condition, args: [...(condition.args as Condition[]), { op: 'eq', args: ['', ''] }] })}>
            Add sub-condition
          </button>
        </div>
      ) : (
        <div className="condition-builder__leaf">
          <label>
            Field
            <input
              list="field-names"
              value={typeof condition.args?.[0] === 'string' ? (condition.args[0] as string).replace(/^\$/, '') : ''}
              onChange={(e) => onChange({ ...condition, args: [`$${e.target.value}`, condition.args?.[1] ?? ''] })}
            />
            <datalist id="field-names">
              {fieldNames.map((n) => <option key={n} value={n} />)}
            </datalist>
          </label>
          <label>
            Value
            <input
              value={String(condition.args?.[1] ?? '')}
              onChange={(e) => onChange({ ...condition, args: [condition.args?.[0] ?? '', e.target.value] })}
            />
          </label>
        </div>
      )}
    </div>
  );
}
